module.exports = __webpack_public_path__ + "media/images/icons/flags/CW-84d6c9fb2c339705e28ccefc9c1f4b48.svg";